import { http, spider_http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    placing_ads_kol_query,
    placing_ads_record_save,
    placing_ads_record_query,
    placing_ads_record_detail,
    placing_ads_vas_record_save,
    placing_ads_vas_record_delete,
    placing_ads_record_delete,
    placing_ads_record_export,
    placing_ads_record_import,
    placing_ads_kol_export,
    placing_ads_record_close,
    spider_placing_rank,
    placing_ads_record_change_put_grade,
 } = util.api || {}

export function getplacingAdsKolQueryListApi(params) {
    return http.get(placing_ads_kol_query, params)
}

export function postPlacingAdsRecordSaveApi(params) {
    return http.post(placing_ads_record_save, params)
}

export function getplacingAdsRecordQueryApi(params) {
    return http.get(placing_ads_record_query, params)
}

export function getPlacingAdsRecordDetailApi(params) {
    return http.get(placing_ads_record_detail, params)
}

export function postPlacingAdsVasRecordSaveApi(params) {
    return http.post(placing_ads_vas_record_save, params)
}

export function postPlacingAdsVasRecordDeleteApi(params) {
    return http.post(placing_ads_vas_record_delete, params)
}

export function postPlacingAdsRecordDeleteApi(params) {
    return http.post(placing_ads_record_delete, params)
}
// placing_ads_record_close
export function postPlacingAdsRecordCloseApi(params) {
    return http.post(placing_ads_record_close, params)
}
export function getRecordsRank(params) {
    return spider_http.post(spider_placing_rank, params)
}
export function updateRecordGrade(params) {
    return http.post(placing_ads_record_change_put_grade, params)
}
